import { useEffect } from 'react'
import { CopilotTheme, CopilotAuthEndpoints } from '@assembly/constants/copilot'
import type { CopilotEnvironmentType } from '@assembly/types'

interface CopilotProviderProps {
  children: React.ReactNode
}

export function CopilotProvider({ children }: CopilotProviderProps) {
  useEffect(() => {
    if (!window.AssemblyCopilot) {
      console.warn('AssemblyCopilot not loaded. Make sure the script is included in index.html')
      return
    }

    const platform = process.env.REACT_APP_COPILOT_PLATFORM
    const assemblyId = process.env.REACT_APP_CO_PILOT_ASSEMBLY_ID
    const workflowId = process.env.REACT_APP_CO_PILOT_WORKFLOW_ID

    if (!platform) {
      console.warn('REACT_APP_COPILOT_PLATFORM is not set')
      return
    }

    window.AssemblyCopilot.init({
      platform,
      environment: process.env.REACT_APP_ENV as CopilotEnvironmentType,
      theme: CopilotTheme.LIGHT,
      auth: {
        baseUrl: process.env.REACT_APP_ENV_API_BASE_URL,
        endpoints: {
          verify: CopilotAuthEndpoints.VERIFY,
          oneTimeCode: CopilotAuthEndpoints.ONE_TIME_CODE,
          login: CopilotAuthEndpoints.LOGIN,
          logout: CopilotAuthEndpoints.LOGOUT,
        },
      },
    })

    // Set context if env vars are provided
    if (assemblyId && workflowId) {
      window.assemblyCopilot?.setContext(assemblyId, workflowId)
    } else if (assemblyId) {
      window.assemblyCopilot?.setAssemblyId(assemblyId)
    } else if (workflowId) {
      window.assemblyCopilot?.setWorkflowId(workflowId)
    }

    return () => {
      window.AssemblyCopilot?.destroy()
    }
  }, [])

  return <>{children}</>
}

export default CopilotProvider
